<template>
  <div class="nopads">
      <!-- Header of collapsable item -->
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="signsVisible = !signsVisible">
                  {{ $t('contract_reports.road_signs') }} ({{ roadSigns.length }})
              </h4>
          </div>
          <div
              v-if="loading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="signsVisible = !signsVisible">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:signsVisible }"/>
          </div>
      </div>
      <!-- Collapsable content -->
      <div class="routa-collapse" :class="{ collapsed: signsVisible }">
          <road-sign-list :road-signs="roadSigns" class="my-2" @row-clicked="editRoadSign"/>
      </div>
      <hr class="report-divider nopads">
      <road-sign-wizard
          v-if="editSign"
          :road-sign="editSign"
          :user="user"
          @close="editSign = null"
          @close-and-update="closeAndUpdate"
      />
  </div>
</template>

<script>
import {restApi} from "../mixins/RestApiMixin";
import RoadSignList from "../roadsign/RoadSignList";
import RoadSignWizard from "../roadsign/RoadSignWizard";

export default {
    name: "ContractReportRoadSigns",
    components: {RoadSignWizard, RoadSignList},
    mixins: [restApi],
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        },
        user: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            signsVisible: false,
            roadSigns: [],
            editSign: null
        }
    },
    watch: {
        searchParams() {
            this.fetchRoadSigns()
        }
    },
    mounted() {
        this.fetchRoadSigns()
    },
    methods: {
        async fetchRoadSigns() {
            if (this.searchParams && this.searchParams.dateFrom && this.searchParams.dateTo && this.searchParams.contract) {
                this.roadSigns = []
                this.loading = true
                this.$emit('loading', true)
                let params = {
                    created_from: this.searchParams.dateFrom,
                    created_to: this.searchParams.dateTo,
                    contract: this.searchParams.contract
                }
                try {
                    const response = await new Promise(
                        (resolve, reject) => this.restFetchParams(this.roadSignUrl, params, resolve, reject)
                    );
                    this.roadSigns = response.data
                }
                finally {
                    this.$emit('loading', false)
                    this.loading = false
                }
            }
        },
        editRoadSign(data) {
            this.editSign = data
        },
        closeAndUpdate() {
            this.editSign = null
            this.fetchRoadSigns()
        }
    }
}
</script>
